import {
    Paper, Table, TableCell, TableContainer, TableHead,
    TableRow, withStyles
} from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import Modal from "@mui/material/Modal";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import {
    getProjectSamples
} from "../actions/GenomicsResearchAction";
import "./filter.sass";
let width = window.innerWidth;
let isMobile = width <= 500;

const useStyles = makeStyles((theme) => ({
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: "2px solid #000",
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        width: isMobile ? "400px" : "1200px",
    },
    tableContainer: {
        marginTop: "2rem",
        position: "sticky",
        top: "200px",
    },
})
);
const StyledTableCell: any = withStyles((theme: Theme) =>
    createStyles({
        head: {
            backgroundColor: "#12145e",
            color: theme.palette.common.white,
            fontSize: "14px",
        },
        body: {
            fontSize: 14,
        },
    })
)(TableCell);

const StyledTableRow: any = withStyles((theme: Theme) =>
    createStyles({
        root: {
            "&:nth-of-type(odd)": {
                backgroundColor: theme.palette.action.hover,
            },
        },
    })
)(TableRow);

type ModalProps = {
    openModal: boolean;
    setopenModal: Function;
    projectSamplesData: any;
    getProjectSamples: any;
    ProjectSamples: any;
};

const PerformanceModal: React.FC<ModalProps> = ({
    openModal,
    setopenModal,
    projectSamplesData,
    getProjectSamples,
    ProjectSamples,
}) => {
    const classes = useStyles();
    const { id } = useParams<{ id: string }>();
    const handleClose = () => {
        setopenModal(false);
    };
    useEffect(() => {
        if (projectSamplesData)
            getProjectSamples(`?project=${projectSamplesData}`);
    }, [projectSamplesData])
    return (
        <div style={{ width: "100%" }}>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={openModal}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
                style={{ maxWidth: 1200, margin: "0px auto" }}
            >
                <Fade in={openModal} style={{ margin: 20 }}>
                    <TableContainer
                        className={classes.tableContainer}
                        component={Paper}
                        style={{ maxHeight: "700px" }}
                    >
                        <Table stickyHeader aria-label="simple table">
                            <TableHead>
                                <StyledTableRow>
                                    <StyledTableCell align="center">Sample ID</StyledTableCell>
                                    <StyledTableCell align="center">Sample Name</StyledTableCell>
                                    <StyledTableCell align="center">Sample Type</StyledTableCell>
                                    <StyledTableCell align="center">Storage Status</StyledTableCell>
                                    <StyledTableCell align="center">Sample Qc Status</StyledTableCell>
                                    <StyledTableCell align="center">Library Status</StyledTableCell>
                                </StyledTableRow>
                            </TableHead>
                            <TableBody>
                                {ProjectSamples && ProjectSamples?.results && ProjectSamples?.results?.length > 0 && ProjectSamples?.results?.map((data: any, index: any) => {
                                    return (
                                        <StyledTableRow >
                                            <StyledTableCell align="center">
                                                {data?.sampleId}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {data?.name}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {data?.qc?.sampleType}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {data?.storage ? "Done" : "Pending"}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {data?.qc?.qcStatus}
                                            </StyledTableCell>
                                            <StyledTableCell align="center">
                                                {data?.libraries?.length === 0 ? "Pending" :data?.libraries?.length > 0 && data?.libraries?.map((val: any) => val?.status)}
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    )
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Fade>
            </Modal>
        </div>
    );
};
const mapStateToProps = (state: any) => ({
    ProjectSamples: state.GenomicsCAReducer.ProjectSamples,
});

export default connect(mapStateToProps, {
    getProjectSamples,

})(PerformanceModal);
